import dashboard1APIsService from "../dashboard1APIs";
import { createDataHook } from "../../helpers/util";
import { GOOGLE_CHARTS_TYPES } from "../../consts/graphs";

const useFetchDashboard1Data = createDataHook(
  dashboard1APIsService,
  (filters, params, controller, apiService = dashboard1APIsService) => ({
    fetchSummaryCardsData: () =>
      apiService.fetchSummaryCardsData(filters, controller.signal),
    fetchNewUsersPerMonthData: () =>
      apiService.fetchNewUsersPerMonthData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BAR },
        controller.signal
      ),
    fetchMonthlyUserActivityData: () =>
      apiService.fetchMonthlyUserActivityData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BARCHART },
        controller.signal
      ),
    fetchMostLeastCompliantCoursesData: () =>
      apiService.fetchMostLeastCompliantCoursesData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BARCHART },
        controller.signal
      ),
    fetchUsersByComplianceGroupData: () =>
      apiService.fetchUsersByComplianceGroupData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.COLUMNCHART },
        controller.signal
      ),
    fetchOrganisationsByComplianceGroupData: () =>
      apiService.fetchOrganisationsByComplianceGroupData({
        ...params,
        chartType: GOOGLE_CHARTS_TYPES.COLUMNCHART,
      }, controller.signal),
    fetchOrganisationCourseSummaryData: () =>
      apiService.fetchOrganisationCourseSummaryData({
        ...params,
        chartType: GOOGLE_CHARTS_TYPES.TABLE,
      }, controller.signal),
    fetchMiReportData: () =>
      apiService.fetchMiReportData({
        ...params,
        chartType: GOOGLE_CHARTS_TYPES.TABLE,
      }, controller.signal),
    fetchMostLeastCompliantOrganisationsData: () =>
      apiService.fetchMostLeastCompliantOrganisationsData({
        ...params,
        //sortBy: "compliantPercentage",
        //sortOrder: "desc",
      }, controller.signal),
    fetchMostLeastCompliantRolesData: () =>
      apiService.fetchMostLeastCompliantRolesData({
        ...params,
        //sortBy: "compliantPercentage",
        //sortOrder: "desc",
      }, controller.signal),
    fetchMostLeastCompliantSitesData: () =>
      apiService.fetchMostLeastCompliantSitesData({
        ...params,
        //sortBy: "compliantPercentage",
        //sortOrder: "desc",
      }, controller.signal),
  }),
  { preflight: "shared" }
);

export default useFetchDashboard1Data;
